import "core-js/modules/es.object.assign.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/*
 * @Author       : 程哲林
 * @Date         : 2022-05-25 17:24:49
 * @LastEditors  : 程哲林
 * @LastEditTime : 2022-07-19 18:01:40
 * @FilePath     : /marketing-landing-fe/src/lib/i18next.ts
 * @Description  : 未添加文件描述
 */


import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en_US from '@/locales/en_US';
import zh_CN from '@/locales/zh_CN';
import zh_TW from '@/locales/zh_TW';
var detectorConf = {
  detection: {
    lookupLocalStorage: 'hl',
    lookupCookie: 'hl',
    caches: []
  }
};
i18next.use(LanguageDetector).init(__assign(__assign({}, detectorConf), {
  resources: {
    'zh-CN': {
      translation: zh_CN
    },
    'zh-TW': {
      translation: zh_TW
    },
    'en-US': {
      translation: en_US
    },
    en: {
      translation: en_US
    },
    zh: {
      translation: zh_CN
    }
  },
  fallbackLng: ['zh-TW', 'zh-CN', 'en-US']
}));
export var _trans = i18next.t;
export default i18next;